import { TERMINAL_UPLOAD_PHASES } from '../config/transferLifecycle';
import type { UploadPhase } from '../types/uploads';

/** Phases that need no further byte/status work. */
export const TERMINAL_PHASES = TERMINAL_UPLOAD_PHASES;

export function isTerminalPhase(phase: UploadPhase): boolean {
  return TERMINAL_PHASES.has(phase);
}
